import { useTheme } from "@mui/material";
import { useMemo } from "react";
import { useDashboardOverviewQuery } from "web_myplann/Api/Dashboard/useDashboardOverviewQuery";
import { useDashboardData } from "web_myplann/Dashboard/Hooks/useDashboardData";
import { useIsDashboardV2 } from "web_myplann/Dashboard/State/dashboardVariantContext";
import type { DashboardSlide } from "web_myplann/Dashboard/Types/DashboardSlide";

const GOALS_SLIDE_ID = -1;

export const useDashboardSlides = () => {
	const isDashboardV2 = useIsDashboardV2();
	const { dashboard } = useTheme();
	const { dashboards, isLoading: isDashboardsLoading } = useDashboardData();
	const { data: dashboardOverview, isLoading: isDashboardOverviewLoading } =
		useDashboardOverviewQuery(isDashboardV2);
	const goalOverview = dashboardOverview?.goals;

	const isLoading = isDashboardsLoading || isDashboardOverviewLoading;

	const slides = useMemo<DashboardSlide[]>(() => {
		if (isLoading) {
			return [];
		}
		return isDashboardV2 && goalOverview && goalOverview.totalCount > 0
			? [
					...dashboards,
					{
						id: GOALS_SLIDE_ID,
						gradientFrom: dashboard.gradients.goals.from,
						gradientTo: dashboard.gradients.goals.to,
						goalOverview,
					},
				]
			: dashboards;
	}, [
		isLoading,
		isDashboardV2,
		dashboards,
		goalOverview,
		dashboard.gradients.goals,
	]);

	return {
		slides,
		isLoading,
		isEmpty: slides.length === 0,
	};
};
